import Crud from '../views/Grupo/Crud'
import Entity from '../views/Grupo/Add'

let routes = {
    path: '/grupos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/grupos/add',
            name: 'NewGrupo',
            component: Entity
        },
        {
            path: '/grupos/edit/:id?',
            name: 'EditGrupo',
            component: Entity
        },
        {
            path: '/grupos',
            name: 'list-grupos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Grupos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
